import { cn } from '@/lib/utils';

interface MoBrainIconProps {
  className?: string;
}

export const MoBrainIcon: React.FC<MoBrainIconProps> = ({ className }) => (
  <img
    src="/Mobrain.png"
    alt="MoBrain"
    className={cn('object-contain', className)}
  />
);
